import fromPairs from 'lodash/fromPairs';

import { countries } from '../constants';
import { convertToEnumWithOptions } from '../utils/convert-to-option';

export const countryOptions = countries.map(country => ({
  label: country.label,
  value: country.countryCode,
  isDisabled: country.isDisabled,
}));

export const genders = [
  { label: 'Women', value: 'Women' },
  { label: 'Men', value: 'Men' },
  { label: 'Kids', value: 'Kids' },
];

export const flexibilityTermsValues = {
  FULL_FLEXIBILITY: 'Full flexibility',
  LIMITED_FLEXIBILITY: 'Limited flexibility',
};

export const flexibilityTermsOptions = Object.values(
  convertToEnumWithOptions(flexibilityTermsValues),
);

export const allowedFlexibilitiesValues = {
  ADD_REMOVE_MARKETS: 'Add/Remove Markets',
  ADD_REMOVE_GENDERS: 'Add/Remove Genders',
  MAXBID_OPT: 'MaxBid Optimization',
  SKU_OPT: 'SKU Optimization',
  BUDGET_SHIFT: 'Budget Shift',
  FLEXIBILE_TARGET_KPI: 'Flexible Target KPI',
  FLEXIBILE_CPC_CPV: 'Flexible CPC / CPV',
  RUNTIME: 'Runtime',
  ACHIEVING_TARGET: 'Achieving the Target',
  DELIVERING_BIDGET: 'Delivering the Budget',
  NO_FLEXIBILITY: 'No flexibility',
};

export const allowedFlexibilitiesOptions = Object.values(
  convertToEnumWithOptions(allowedFlexibilitiesValues),
);

export const emptyCountrySplit = fromPairs(
  countries.map(ea => [ea.countryCode, 0]),
);

export const PricingModels = {
  FEE_PERCENT: 'Fee (%)',
  FEE_FLAT: 'Flat Fee',
  CPC: 'CPC',
  CPV: 'CPV',
  MONTHLY_FEE: 'Monthly Fee',
  YEARLY_FEE: 'Yearly Fee',
  DAILY_RATE: 'Daily Rate',
  CUSTOM_OFFER: 'Custom Offer',
};

export const quoteFilterFields = ['name', 'id'];

export const quoteSelectLabel = object => {
  return `${object.id} ${object.name}`;
};
